<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}">
        <navbar-toggle-button @click.native="toggleSidebar"></navbar-toggle-button>
      </div>
      <a class="navbar-brand" href="#pablo"> {{routeName}}</a>
    </div>

    <el-select v-model="currentLang">
      <el-option
        v-for="lang in langOptions"
        :key="lang.key"
        :label="lang.name"
        :value="lang.key">
      </el-option>
    </el-select>

    <button
      @click="toggleNavbar"
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navigation"
      aria-controls="navigation-index"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    <template slot="navbar-menu">
      <!-- <form>
        <div class="input-group no-border">
          <fg-input placeholder="Search..." addon-right-icon="now-ui-icons ui-1_zoom-bold">
          </fg-input>
        </div>
      </form>-->

      <ul class="navbar-nav">
        <!-- <li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="now-ui-icons media-2_sound-wave"></i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li>-->
        <drop-down tag="li" position="right" class="nav-item" icon="now-ui-icons users_single-02">
          <a class="dropdown-header">{{user.name}}</a>
          <a class="dropdown-item" href="#" v-on:click="logout">Logout</a>
          <!-- <a class="dropdown-item" href="#">Something else here</a> -->
        </drop-down>
        

        <!-- <li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="now-ui-icons users_single-02"></i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li>-->
      </ul>
    </template>
  </navbar>
</template>
<script>
import { RouteBreadCrumb, Navbar, NavbarToggleButton } from "src/components";
import { CollapseTransition } from "vue2-transitions";
import { mapGetters, mapActions } from 'vuex';
import { i18n } from "../../../vue-i18n-plugin"
import { languageOptions } from "src/util/i18n";

export default {
  components: {
    RouteBreadCrumb,
    Navbar,
    NavbarToggleButton,
    CollapseTransition
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return name ? this.$i18n.t(`title.${name}`) : '';
      // return this.capitalizeFirstLetter(name);
    },
    userType: function() {
      return this.$store.getters.userType;
    },
    user: function() {
      // Encrypt 加密
      // var cipherText = CryptoJS.AES.encrypt(
      //   "my message",
      //   "secretkey123"
      // ).toString();
      // console.log(cipherText)
      // // Decrypt 解密
      // var bytes = CryptoJS.AES.decrypt(cipherText, "secretkey123");
      // var originalText = bytes.toString(CryptoJS.enc.Utf8);
      // console.log(originalText); // 'my message'
      return this.$store.getters.user;
    }
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false,
      currentLang: i18n.locale,
      langOptions: languageOptions
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      let self = this;
      let beforeSignout = self.userType;
      this.$store
        .dispatch("logout")
        .then(() => {
          // 接收 resolve
          setTimeout(() => {
            // 使用 $router.push，根據身份跳轉到不同的登入頁面
            switch(beforeSignout) {
              case 'gaa': 
                self.$router.push("/gaa-login");  
                break;
              case 'si':
                self.$router.push("/si-login");
                break;
              case 'eaa': 
                self.$router.push("/eaa-login");
                break;
              case 'line': 
                self.$router.push("/eaa-login");
                break;
              default:
                self.$router.push("/eaa-login");
            }
          }, 1000);
        })
        .catch(e => {
          // 接收 reject
          console.log("error get Promise reject!" + e.stack);
        });
    },
  },
  watch: {
    currentLang: {
      handler(newVal, oldVal) {
        this.$store.dispatch('setLang', newVal);
      },
      immediate: true
    }
  }
};
</script>
<style>
</style>
